import { ButtonFilterProps } from "./FilterButtonInterface";

export const FilterButton = ({ title, onClick, isActive = false }: ButtonFilterProps) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? "bg-blue-500 text-white"
          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
      }`}
    >
      {title}
    </button>
  );
};
  